import { createSlice } from "@reduxjs/toolkit";
import { authUser } from "../../../type/auth/current-user";

export const currentAuthUser = createSlice({
  name: "current-user",
  initialState: {
    value: {
      status: false,
      isLoggedIn: false,
      user: {
      } as authUser,
      token: ""
    },
  },
  reducers: {
    updateCurrrentAuthUser: (state, action) => {
      state.value.status = true
      state.value.isLoggedIn = true
      state.value.user = action.payload?.user;
      state.value.token = action.payload?.token;
    },
    clearCurrentAuthUser: (state) => {
        state.value.status = false
        state.value.isLoggedIn = false 
        state.value.token = "" 
    },
    updateToken: (state, action) => {
      state.value.token = action.payload;
    },
  },
});

export const {
    updateCurrrentAuthUser,
    clearCurrentAuthUser,
    updateToken
} = currentAuthUser.actions;

export default currentAuthUser.reducer;
